import _CURRENCIES from '../../lib/assets/currencies.json'

export const CURRENCIES = _CURRENCIES

export const LOCALES = ['en', 'fr']

export const REVOLUGO_API_URL = process.env.REVOLUGO_API_URL

export const REVOLUGO_PLATFORM_URL = process.env.REVOLUGO_PLATFORM_URL
